import enLang from './entries/en_US';
import ruLang from './entries/ru_RU';

const AppLocale = {
    ru: ruLang,
    en: enLang
};

export default AppLocale;